import * as React from "react";
import { ErrorMessageContext } from "./context.js";
const ErrorMessageProvider = ({ children, initialMessages = [] }) => {
  const [errors, setErrors] = React.useState(initialMessages);
  const hasErrors = errors.length > 0;
  const addError = React.useCallback((error) => {
    setErrors((errors2) => [...errors2, error]);
  }, []);
  const removeError = React.useCallback((error) => {
    setErrors((errors2) => errors2.filter((e) => e !== error));
  }, []);
  const clearErrors = React.useCallback(() => setErrors([]), []);
  const value = React.useMemo(
    () => [
      { addError, removeError, clearErrors },
      { errors, hasErrors }
    ],
    [addError, errors, hasErrors, removeError]
  );
  return /* @__PURE__ */ React.createElement(ErrorMessageContext.Provider, { value }, children);
};
export {
  ErrorMessageProvider
};
//# sourceMappingURL=provider.js.map
